import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { getUniqueKey, isMobile } from '../../../../utils/HTMLutils'
import { formatHexadecimalColor } from '../../../../utils/MaskUtils'
import { validaHexadecimalColor } from '../../../../utils/ValidationUtils'
import TextEditorHeaderInput from '../textEditorInput/TextEditorHeaderInput'
import TextEditorMenuButton from '../textEditorMenuButton/TextEditorMenuButton'
import './TextEditorColorPicker.scss'
const rootClassName = 'text-editor-color-picker'
const colorClassName = `${rootClassName}-color-button`

const defaultColors = [
  '#121212',
  '#323c32',
  '#5a645a',
  '#828a82',
  '#33820d',
  '#3fa110'
]
const ColorButton = (props) => (
  <button
    disabled={props.disabled}
    className={colorClassName}
    onClick={() => props.onClick(props.color)}
    style={{ backgroundColor: props.color }}
  />
)
ColorButton.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
}

var timeOutID = null
export default function TextEditorColorPicker(props) {
  const [hexa, setHexa] = useState('')
  const [id] = useState(getUniqueKey())
  const [previousSelection, setPreviousSelection] = useState({})
  useEffect(() => {
    setHexa(props.atualColor)
  }, [props.atualColor])

  useEffect(() => {
    if (props.opened) {
      const {
        anchorNode,
        anchorOffset,
        focusNode,
        focusOffset
      } = window.getSelection()
      setPreviousSelection({ anchorNode, anchorOffset, focusNode, focusOffset })
      const el = document.querySelector(`#${id} input:nth-of-type(2)`)
      if (el) {
        el.focus()
        if (isMobile()) {
          el.blur()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opened])

  const lastUsedColors = JSON.parse(
    window.localStorage.getItem('lastUsedColors')
  ) || ['', '', '', '', '', '']

  const submitColor = (color) => {
    window
      .getSelection()
      .setBaseAndExtent(
        previousSelection.anchorNode,
        previousSelection.anchorOffset,
        previousSelection.focusNode,
        previousSelection.focusOffset
      )
    props.onChange(color)
  }

  const handleSubmit = () => {
    if (!validaHexadecimalColor(hexa)) return
    window
      .getSelection()
      .setBaseAndExtent(
        previousSelection.anchorNode,
        previousSelection.anchorOffset,
        previousSelection.focusNode,
        previousSelection.focusOffset
      )
    props.onChange(hexa)
    const arr = [
      hexa,
      lastUsedColors[0] || '',
      lastUsedColors[1] || '',
      lastUsedColors[2] || '',
      lastUsedColors[3] || '',
      lastUsedColors[4] || ''
    ]
    setTimeout(() => {
      window.localStorage.setItem('lastUsedColors', JSON.stringify(arr))
    }, 250)
  }

  return (
    <div id={id} className={rootClassName}>
      <div className={`${rootClassName}-colors`}>
        {defaultColors.map((color, index) => {
          return (
            <ColorButton
              key={index}
              color={color}
              onClick={(color) => submitColor(color)}
            />
          )
        })}
      </div>
      <div className={`${rootClassName}-colors`}>
        {lastUsedColors.map((color, index) => {
          return (
            <ColorButton
              key={index}
              disabled={color === ''}
              color={color}
              onClick={(color) => submitColor(color)}
            />
          )
        })}
      </div>
      <div className={`${rootClassName}-hexa-row`}>
        <div className={`${rootClassName}-picker-col`}>
          <input
            value={hexa}
            onChange={(evt) => {
              evt.stopPropagation()
              const val = evt.target.value
              if (timeOutID) clearTimeout(timeOutID)
              timeOutID = setTimeout(() => {
                setHexa(val)
              }, 200)
            }}
            className={`${rootClassName}-color-picker`}
            type='color'
          />
        </div>
        <TextEditorHeaderInput
          label='Hexadecimal'
          onChange={(evt) => setHexa(formatHexadecimalColor(evt.target.value))}
          value={hexa}
          onEnter={handleSubmit}
        />
        <TextEditorMenuButton
          disabled={!validaHexadecimalColor(hexa)}
          onClick={handleSubmit}
          style={{ width: '25%' }}
        >
          OK
        </TextEditorMenuButton>
      </div>
    </div>
  )
}

TextEditorColorPicker.propTypes = {
  onChange: PropTypes.func,
  atualColor: PropTypes.string,
  opened: PropTypes.bool
}

TextEditorColorPicker.defaultProps = {
  onChange: () => {}
}
